import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, Calendar, ArrowRight, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

const ParticipateSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || "application";
  
  const isPayment = type === "payment";

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center py-20" data-testid="success-page">
      <div className="max-w-2xl mx-auto px-6 text-center">
        {/* Success Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 bg-green-500/20 border-2 border-green-500 mb-8">
          <CheckCircle className="text-green-500" size={40} />
        </div>
        
        {/* Title */}
        <h1 className="font-serif text-white text-3xl md:text-4xl font-bold mb-4">
          {isPayment ? "Registration Confirmed" : "Application Received"}
        </h1>
        
        {/* Message */}
        <p className="font-body text-white/70 text-lg mb-8 max-w-xl mx-auto">
          {isPayment 
            ? "Thank you for registering for She Built This — Edition 001. You will receive a confirmation email with all event details within 24 hours."
            : "Thank you for your application. We review every submission carefully and will be in touch within 2 weeks."}
        </p>
        
        {/* What's Next */}
        <div className="bg-[#0f0f0f] border border-gold-500/30 p-8 mb-8 text-left">
          <h2 className="font-heading text-gold-500 text-sm tracking-widest mb-4">WHAT HAPPENS NEXT</h2>
          <div className="space-y-4">
            <div className="flex items-start gap-4">
              <Mail className="text-gold-500 flex-shrink-0 mt-1" size={18} />
              <div>
                <p className="font-heading text-white text-sm font-medium">Check your inbox</p>
                <p className="font-body text-white/50 text-sm">
                  {isPayment 
                    ? "Confirmation email with ticket and event details arriving soon."
                    : "We'll email you within 2 weeks about your application status."}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Calendar className="text-gold-500 flex-shrink-0 mt-1" size={18} />
              <div>
                <p className="font-heading text-white text-sm font-medium">Save the date</p>
                <p className="font-body text-white/50 text-sm">
                  She Built This — Edition 001 · 2026 · UAE
                </p>
              </div>
            </div>
          </div>
        </div>
        
        {/* The Pledge Preview */}
        <div className="border-l-2 border-gold-500 pl-6 mb-8 text-left">
          <p className="font-serif text-white/70 italic">
            "I am a builder. I have built with opportunity, safety and resources that others have never known. I am a She Built This builder. And my work continues."
          </p>
        </div>
        
        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/stories">
            <Button className="rounded-none px-8 py-4 bg-gold-500 text-[#0a0a0a] font-heading font-bold hover:bg-gold-400">
              Explore Builder Profiles
              <ArrowRight className="ml-2" size={18} />
            </Button>
          </Link>
          <Link to="/">
            <Button 
              variant="outline" 
              className="rounded-none px-8 py-4 border-white/30 text-white font-heading hover:bg-white/10"
            >
              Return Home
            </Button>
          </Link>
        </div>
        
        {/* Footer Note */}
        <p className="font-body text-white/40 text-sm mt-12">
          Questions? Contact us at support@shebuiltthis.com
        </p>
      </div>
    </div>
  );
};

export default ParticipateSuccessPage;
